module.exports = __webpack_public_path__ + "img/Pool-Nachos.35d69389.jpg";